import {
  AC_NODETYPE_DEFINITION,
  AC_NODETYPE_OPERATOR,
  AC_NODETYPE_DATAPOINT,
  AC_NODETYPE_FUNC,
} from '../AutocodeConstants';
import AutocodeLabelsGenerator, {
  ACStandardLabels,
} from '../AutocodeLabelsGenerator';
import AutocodeExpressionListGenerator from '../AutocodeExpressionListGenerator';
import { useSelector, useDispatch } from '../../common/react-redux-hooks';
import {
  // getSampleWeighted,
  // getSampleWeightedData,
  getAutocodeSampleWeighted,
} from '../../../actions/crosstabActions';
import { getAllDefintionsorDictionaryNodes } from '../../../util/autocodeUtils';

const AutocodeSampleWeighted = () => {
  const { loginResponse, partsToShow } = useSelector(state => ({
    loginResponse: state.login.loginResponse,
    partsToShow: state.crosstab.partsToShow,
  }));
  const dispatch = useDispatch();
  const { toDefString } = AutocodeLabelsGenerator(ACStandardLabels, null);
  const { buildObjectsAddedArray } = AutocodeExpressionListGenerator();

  const getsampleWeightedlists = contents => {
    const expressionList = [];
    const selectedNames = [];
    const dataSmartSearch = [];
    const isLabelUpdated = [];
    // console.log('Contents: ', contents);

    // eslint-disable-next-line no-restricted-syntax
    for (const node of contents) {
      if (node.type === AC_NODETYPE_DEFINITION) {
        const tmpDataSmartSearch = {
          expressionFormed: [],
          objectsAdded: [],
          tags: [],
          autocodenode: null,
        };
        node.data.shortTextCatgView = node.data.title;
        expressionList.push(node.data.expression);
        selectedNames.push(node.data.title);
        tmpDataSmartSearch.expressionFormed.push(node.data.expression);
        tmpDataSmartSearch.objectsAdded.push(node.data);
        tmpDataSmartSearch.autocodenode = node;
        tmpDataSmartSearch.tags.push(node.data.title);
        dataSmartSearch.push(tmpDataSmartSearch);
        isLabelUpdated.push(node.useLabelOverride);
      } else if (node.type === AC_NODETYPE_OPERATOR) {
        const tmpDataSmartSearch = {
          expressionFormed: [],
          objectsAdded: [],
          tags: [],
        };
        // let expressionListString = '';
        // let selectedNamesString = '';
        tmpDataSmartSearch.objectsAdded.push(
          ...buildObjectsAddedArray(node, partsToShow)
        );
        tmpDataSmartSearch.autocodenode = node;

        // tmpDataSmartSearch.objectsAdded.forEach(item => {
        //   if (item.expression && item.title) {
        //     tmpDataSmartSearch.expressionFormed.push(item.expression);
        //     tmpDataSmartSearch.tags.push(item.title);
        //     expressionListString = `${expressionListString} ${item.expression}`;
        //     selectedNamesString = `${selectedNamesString} ${item.title}`;
        //   } else {
        //     expressionListString = `${expressionListString} ${item.keyword}`;
        //     selectedNamesString = `${selectedNamesString} ${item.keyword}`;
        //   }
        // });

        expressionList.push(node.toExpressionString());
        selectedNames.push(node.toLabelString(partsToShow));
        // expressionList.push(expressionListString);
        // selectedNames.push(selectedNamesString);
        isLabelUpdated.push(node.useLabelOverride);
        dataSmartSearch.push(tmpDataSmartSearch);
      } else if (node.type === AC_NODETYPE_DATAPOINT) {
        const tmpDataSmartSearch = {
          expressionFormed: [],
          objectsAdded: [],
          tags: [],
        };
        // node.data.shortTextCatgView = node.data.title;
        expressionList.push(node.toExpressionString());
        selectedNames.push(node.toLabelString(partsToShow));
        tmpDataSmartSearch.expressionFormed.push(node.toExpressionString());
        tmpDataSmartSearch.objectsAdded.push(node.data);
        tmpDataSmartSearch.autocodenode = node;
        tmpDataSmartSearch.tags.push(node.toLabelString(partsToShow));
        dataSmartSearch.push(tmpDataSmartSearch);
        isLabelUpdated.push(node.useLabelOverride);
      } else if (node.type === AC_NODETYPE_FUNC) {
        // jedK needs to be reviewed
        const tmpDataSmartSearch = {
          expressionFormed: [],
          objectsAdded: [],
          tags: [],
        };
        // node.data.shortTextCatgView = node.data.title;
        expressionList.push(node.toExpressionString());
        selectedNames.push(node.toLabelString(partsToShow));
        tmpDataSmartSearch.expressionFormed.push(node.toExpressionString());
        tmpDataSmartSearch.objectsAdded = getAllDefintionsorDictionaryNodes(
          node
        );
        tmpDataSmartSearch.autocodenode = node;
        tmpDataSmartSearch.tags.push(node.toLabelString(partsToShow));
        dataSmartSearch.push(tmpDataSmartSearch);
        isLabelUpdated.push(node.useLabelOverride); // node.isLabelUpdated is being hardcoded to true
        // now to be in align with dictionary search functions
      }
    }
    // const nielsenPresent = isNielsenStudyPresent(dropItem.selectedNodes);
    // if (dropItem.selectedNodes.constructor === Array) {
    //   dropItem.selectedNodes.forEach((item, index) => {
    //     if (nielsenPresent && item.rectype === 'N') {
    //       expressionList[index] = `${expressionList[index]} >= 1`;
    //     }
    //   });
    // }

    return { expressionList, selectedNames, dataSmartSearch, isLabelUpdated };
  };

  const SampleWeightedCall = (
    targetGrid,
    extractedContents,
    ExistingGridData,
    moduleStudy,
    selectedWeightType,
    activeAccountId,
    uid,
    sampleWeightedKPIs
  ) => {
    // const removeDuplicates = list => {
    //   const uniqueList = [];
    //   const expressionList = [];
    //   list.forEach(item => {
    //     if (item.useLabelOverride) {
    //       uniqueList.push(item);
    //     } else if (item.type === AC_NODETYPE_DEFINITION) {
    //       if (
    //         uniqueList.filter(value => {
    //           return value.data.expressionId === item.data.expressionId;
    //         }).length === 0 ||
    //         (uniqueList.filter(value => {
    //           return value.data.uniqueId === item.data.uniqueId;
    //         }).length === 1 &&
    //           uniqueList.filter(value => {
    //             return value.data.uniqueId === item.data.uniqueId;
    //           })[0].useLabelOverride)
    //       ) {
    //         uniqueList.push(item);
    //       }
    //     } else if (item.type === AC_NODETYPE_OPERATOR) {
    //       const expressionString = toDefString(item);

    //       if (!expressionList.includes(expressionString)) {
    //         uniqueList.push(item);
    //         expressionList.push(expressionString);
    //       }
    //     } else if (item.type === AC_NODETYPE_DATAPOINT) {
    //       if (
    //         uniqueList.filter(value => {
    //           return value.data.uniqueId === item.data.uniqueId;
    //         }).length === 0 ||
    //         (uniqueList.filter(value => {
    //           return value.data.uniqueId === item.data.uniqueId;
    //         }).length === 1 &&
    //           uniqueList.filter(value => {
    //             return value.data.uniqueId === item.data.uniqueId;
    //           })[0].useLabelOverride)
    //       ) {
    //         uniqueList.push(item);
    //       }
    //     } else if (item.type === AC_NODETYPE_FUNC) {
    //       const expressionString = toDefString(item);

    //       if (!expressionList.includes(expressionString)) {
    //         uniqueList.push(item);
    //         expressionList.push(expressionString);
    //       }
    //     }
    //   });
    //   return uniqueList;
    // };
    // const geographyBase = GEOGRAPHY_BASES.some(base =>
    //   extractedContents[0].data.expression.includes(base)
    // );
    // const rectype = 'B';
    // if (geographyBase) {
    //   rectype = 'L';
    // }

    // const paramData = getsampleWeightedlists(
    //   removeDuplicates(extractedContents)
    // );
    const paramData = getsampleWeightedlists(extractedContents);
    // console.log('paramData2:', paramData);

    const gridData =
      targetGrid === 'ColumnsDataGrid'
        ? ExistingGridData.ColumnsDataGrid
        : targetGrid === 'RowsDataGrid'
        ? ExistingGridData.RowsDataGrid
        : ExistingGridData.BasesDataGrid;

    const sampleWeightedParams = {
      targetGrid,
      token: loginResponse.data.token,
      uid,
      accountId: activeAccountId,
      productNo: moduleStudy.pn,
      weightType: selectedWeightType.wt,
      divisor: selectedWeightType.dv,
      gridData,
      expressionList: paramData.expressionList,
      selectedNames: paramData.selectedNames,
      sourceGrid: 'AutocodeSelectionBox',
      // recTypes: [rectype],
      // userDefinedText: false,
      isLabelUpdated: paramData.isLabelUpdated,
      objSmartSearchArray: paramData.dataSmartSearch,
    };

    // let kpiNotExistsFlag = false;
    // const responseData = [];
    // paramData.expressionList.forEach(elems => {
    //   if (sampleWeightedKPIs[elems] === undefined) {
    //     kpiNotExistsFlag = true;
    //   } else {
    //     responseData.push(sampleWeightedKPIs[elems].data[0]);
    //   }
    // });

    // if (!kpiNotExistsFlag) {
    //   sampleWeightedParams.response = responseData;
    //   dispatch(getSampleWeightedData(sampleWeightedParams));
    // } else {
    dispatch(getAutocodeSampleWeighted(sampleWeightedParams));
    // }
    // console.log('sampleWeightedParams2:', sampleWeightedParams);
  };

  return { SampleWeightedCall };
};

export default AutocodeSampleWeighted;
